import { render, staticRenderFns } from "./AStaffDetailPurchaseApply.vue?vue&type=template&id=785febdc&scoped=true"
import script from "./AStaffDetailPurchaseApply.vue?vue&type=script&lang=js"
export * from "./AStaffDetailPurchaseApply.vue?vue&type=script&lang=js"
import style0 from "./AStaffDetailPurchaseApply.vue?vue&type=style&index=0&id=785febdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785febdc",
  null
  
)

export default component.exports